import { AirOutlined, DataArray, DataArrayOutlined, DataArrayRounded, DateRange, Description, DeveloperBoard, DeveloperMode, Email, EmailOutlined, FileCopySharp, FileCopyTwoTone, LocationCity, NewspaperOutlined, Notifications, Numbers, QuestionAnswer, Report, ReportOutlined, Subscriptions, TypeSpecimen, VerifiedUser, SmartToy } from '@mui/icons-material'
import { BsDatabase, BsDatabaseFillAdd, BsFileExcel, BsFilePlus, BsGlobe, BsGlobeCentralSouthAsia, BsType } from 'react-icons/bs'
import { FaBitcoin, FaCalendarTimes, FaCashRegister, FaCode, FaFile, FaFileExcel, FaFilePdf, FaGlobe, FaGlobeAsia, FaIdCard, FaImage, FaIndustry, FaInternetExplorer, FaLayerGroup, FaMailBulk, FaNewspaper, FaSteam, FaUpload, FaUser, FaUserClock, FaUserInjured, FaUserTie, FaVideo, FaWeibo, FaWeight } from 'react-icons/fa'
import { GoGlobe, GoOrganization } from 'react-icons/go'
import { MdDashboard, MdDriveFileRenameOutline, MdLink, MdMarkEmailUnread, MdNotificationsActive, MdOutlineMarkEmailUnread, MdQueryBuilder, MdReport, MdRestartAlt, MdSubscriptions, MdTransform } from 'react-icons/md'
import { FaRegNewspaper } from "react-icons/fa6";
import { DiUbuntu } from "react-icons/di";
import { TbListDetails } from "react-icons/tb";

export const typeEnmus = {
	"DataCollection":{"label":"Data Collection & Enrichment","logo":<DataArrayOutlined />},
	"NewsletterManagement":{"label":"Newsletter Management","logo":<NewspaperOutlined />},
	"AITools":{"label":"AI Tools","logo":<AirOutlined />},
	"ReportsTools":{"label":"Reports Tools","logo":<Report />},
	"CompanyDBTools":{"label":"CompanyDB Tools","logo":<DataArrayRounded />},
	// "CustomerManagementTools":{"label":"Customer Management Tools","logo":<FaUserInjured />},
	"SubscriptionManagement&Activations":{"label":"Subscription Management & Activations","logo":<Subscriptions />},
	"User&Communication":{"label":"User & Communication","logo":<VerifiedUser />},
	"DevTools":{"label":"Dev Tools","logo":<DeveloperMode />}
}

export const options = [
    {value:'urlScrapper',label:'Url Scrapper',icon:<FaGlobe/>,type: typeEnmus.DataCollection.label},
    {value:'fileUploader',label:'File Uploader',icon:<FaFile/>,type: typeEnmus.AITools.label},
	{value:'dalle-img-gen',label:'Dalle Img Generator',icon:<FaFile/>,type: typeEnmus.AITools.label},
	{value:'playground',label:'Playground',icon:<FaInternetExplorer/>,type: typeEnmus.AITools.label},
	{value:'playground_v2',label:'Playground V2',icon:<FaInternetExplorer/>,type: typeEnmus.AITools.label},
	{value:'cb-enrichment',label:'CB Enrichment',icon:<DataArray/>,type: typeEnmus.DataCollection.label},
    {value:'V2fileUploader',label:'Publish Report',icon:<FaFile/>,type: typeEnmus.ReportsTools.label},
    {value:'ActivationEmailTrial',label:'Activation Email Trial',icon:<MdOutlineMarkEmailUnread/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:'ActivationEmailPaid',label:'Activation Email Paid',icon:<MdMarkEmailUnread/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:'taskRestarter',label:'Task Restarter',icon:<MdRestartAlt/>,type:typeEnmus['DevTools'].label},
    {value:'dashboardTiles',label:'Dashboard View',icon:<MdDashboard/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    // {value:"subscriptions",label:'Subscriptions',icon:<MdSubscriptions/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
	{value:"subscriptions-v2",label:'Subscriptions V2',icon:<MdSubscriptions/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:'layouts',label:"Layouts",icon:<FaLayerGroup/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:'companyRequests',label:'Company Requests',icon:<FaMailBulk/>,type:typeEnmus['CompanyDBTools'].label},
    {value:'companyMigrations',label:'Company Migrations',icon:<MdTransform/>,type:typeEnmus['CompanyDBTools'].label},
    {value:"generateActivationLink",label:'Generate Activation Link',icon:<MdLink/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:"ActivationEmailBulkAddition",label:'Activation Email Bulk',icon:<FaMailBulk/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
    {value:"FileUploads",label:'File Uploads',icon:<FaUpload/>,type:typeEnmus['DataCollection'].label},
    {value:"AllOrganisation",label:'All Organisation',icon:<GoOrganization/>,type:typeEnmus['User&Communication'].label},
    {value:"AllUsers",label:'All Users',icon:<FaUser/>,type:typeEnmus['User&Communication'].label},
	{value:"pending-requests",label:'Full Platform Pending Requests',icon:<FaUser/>,type:typeEnmus['User&Communication'].label},
    {value:"addCompany",label:'Add Company',icon:<BsFilePlus/>,type:typeEnmus['CompanyDBTools'].label},
	{value:"all-configs",label:'Newsletter view',icon:<FaNewspaper/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"report-page-firmographics",label:'Extented Report View',icon:<FaFilePdf/>,type:typeEnmus['ReportsTools'].label},
	{value:"report-migrations",label:'Report Migration',icon:<FaFilePdf/>,type:typeEnmus['ReportsTools'].label},
	{value:"chat-migrations",label:'Chat Migration',icon:<QuestionAnswer/>,type:typeEnmus['ReportsTools'].label},
	{value:"chat-editor",label:'Chat Editor',icon:<Description/>,type:typeEnmus['ReportsTools'].label},
	{value:"email-sender",label:'Email Sender',icon:<EmailOutlined/>,type:typeEnmus['User&Communication'].label},
	{value:"bulk-report-copy",label:'Bulk report copy',icon:<FaFilePdf/>,type:typeEnmus['ReportsTools'].label},
	{value:"bulk-org-report-copy",label:'Bulk Org report copy',icon:<FaFilePdf/>,type:typeEnmus['ReportsTools'].label},
	{value:"newsletter-start",label:'Newsletter Run',icon:<FaNewspaper/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"allposts",label:'Developer Updates',icon:<DeveloperBoard/>,type:typeEnmus['User&Communication'].label},
	{value:"NewsletterReviver",label:'Newsletter Reviver',icon:<DeveloperBoard/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"CosmosResults",label:'Cosmos Results',icon:<BsDatabase/>,type:typeEnmus.AITools.label},
	{value:"market-map-search",label:'Market Map Search',icon:<BsDatabase/>,type:typeEnmus.DataCollection.label},
	{value:"allNotification",label:'All Notification',icon:<Notifications/>,type:typeEnmus['User&Communication'].label},
	{value:"mass_view_all_newsletters",label:'Newsletter Access Management',icon:<FaNewspaper/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"allpreferences?page=User Preferences",label:'User Preference',icon:<FaNewspaper/>,type:typeEnmus['User&Communication'].label},
	{value:"bulkEditPreferences",label:'Bulk Edit Org Preferences',icon:<FaUser/>,type:typeEnmus['User&Communication'].label},
	{value:"scheduler",label:'Scheduler',icon:<FaNewspaper/>,type:typeEnmus['DevTools'].label},
	{value:"qna-data",label:'QnA data',icon:<QuestionAnswer/>,type:typeEnmus.DataCollection.label},
	{value:"all-report-types",label:'All Report Types',icon:<FileCopySharp/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
	{value:"bulk-view-org-products",label:'Bulk View Org Products',icon:<FileCopyTwoTone/>,type:typeEnmus['SubscriptionManagement&Activations'].label},
	{value:"breakpoints",label:'Breakpoints',icon:<FaFileExcel/>,type:typeEnmus.DataCollection.label},
	{value:"company-news/all",label:'Company news',icon:<FaRegNewspaper/>,type:typeEnmus.DataCollection.label},
	{value:"newsletter-config-from-excel",label:'Newsletter Config from excel',icon:<FaRegNewspaper/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"observability-Metrics",label:'Observability Metrics',icon:<DiUbuntu/>,type:typeEnmus['DevTools'].label},
	{value:"observability-logs",label:'Observability Logs',icon:<TbListDetails/>,type:typeEnmus['DevTools'].label},
	{value:"allProductVideo",label:'All Product Video',icon:<FaVideo/>,type:typeEnmus['DataCollection'].label},
	{value:"newsletter-migration",label:'Newsletter Migration',icon:<FaRegNewspaper/>,type:typeEnmus['NewsletterManagement'].label},
	{value:"report-pause",label:'Report Pause',icon:<FaFilePdf/>,type:typeEnmus['DevTools'].label},
	{value:"report-traceability",label:'Report Traceability',icon:<FaRegNewspaper/>,type:typeEnmus['DevTools'].label},
	// {value:"report-tracebility",label:'Report Traceability',icon:<FaRegNewspaper/>,type:typeEnmus['DevTools'].label},
	{value:"english-translator",label:'English Translator',icon:<FaRegNewspaper/>,type:typeEnmus['ReportsTools'].label},
	{value:"db-migration" , label:"DB Migration" , icon:<BsDatabase /> , type:typeEnmus['CompanyDBTools'].label},
	{value:"general-scraper-pdf",label:'General Scraper PDF',icon:<FaFilePdf/>,type:typeEnmus['ReportsTools'].label},
	{value:"atlassearch",label:'Atlas Search',icon:<BsDatabaseFillAdd/>,type:typeEnmus['CompanyDBTools'].label},
	{value:"all-affinity",label:'Affinity Management',icon:<FaWeibo/>,type:typeEnmus['DevTools'].label},
	{value:"ppt_query",label:'PPT Query',icon:<MdQueryBuilder/>,type:typeEnmus['DevTools'].label},
	{value:"edit-ppt-deck",label:'Edit PPT Deck',icon:<FaFilePdf/>,type:typeEnmus['DevTools'].label},
	{value:'image-gen',label:'Image Generator',icon:<FaImage/>,type: typeEnmus.AITools.label},
	{value:'manage-ppt-templates',label:'Manage PPT Templates',icon:<Description/>,type: typeEnmus['DevTools'].label},
	{value:'custom-agents',label:'Custom Agents',icon:<SmartToy/>,type: typeEnmus['SubscriptionManagement&Activations'].label},
	{value:'metric-query-explorer',label:'Metric Query Explorer',icon:<MdQueryBuilder/>,type: typeEnmus['DevTools'].label},
	{value:'credit-management',label:'Credit Management',icon:<FaCashRegister/>,type: typeEnmus['DevTools'].label},
    {value:'minimax-quota',label:'MiniMax Quota',icon:<BsDatabaseFillAdd/>,type: typeEnmus['DevTools'].label},
	{value:'section-wise-credit-distribution',label:'Section Wise Credit Distribution',icon:<BsDatabaseFillAdd/>,type: typeEnmus['DevTools'].label},
    {value:'api-usage',label:'API Usage',icon:<FaCashRegister/>,type: typeEnmus['DevTools'].label},
	{value:'NewsletterEditor',label:'NewsletterEditor',icon:<BsDatabaseFillAdd/>,type: typeEnmus['NewsletterManagement'].label},
	{value:'add-akta-tool',label:'Add New Akta Tool',icon:<FaCode/>,type: typeEnmus['DevTools'].label},
	{value:'add-enterprise-tool',label:'Add New Enterprise Wokelo Tool',icon:<FaCode/>,type: typeEnmus['DevTools'].label},
	{value:'article-groups',label:'Article Groups',icon:<FaLayerGroup/>,type: typeEnmus['DevTools'].label},
]

export const CountryList = [
	"Afghanistan",
	"Albania",
	"Algeria",
	"American Samoa",
	"Andorra",
	"Angola",
	"Anguilla",
	"Antarctica",
	"Antigua and Barbuda",
	"Argentina",
	"Armenia",
	"Aruba",
	"Australia",
	"Austria",
	"Azerbaijan",
	"Bahamas (the)",
	"Bahrain",
	"Bangladesh",
	"Barbados",
	"Belarus",
	"Belgium",
	"Belize",
	"Benin",
	"Bermuda",
	"Bhutan",
	"Bolivia (Plurinational State of)",
	"Bonaire, Sint Eustatius and Saba",
	"Bosnia and Herzegovina",
	"Botswana",
	"Bouvet Island",
	"Brazil",
	"British Indian Ocean Territory (the)",
	"Brunei Darussalam",
	"Bulgaria",
	"Burkina Faso",
	"Burundi",
	"Cabo Verde",
	"Cambodia",
	"Cameroon",
	"Canada",
	"Cayman Islands (the)",
	"Central African Republic (the)",
	"Chad",
	"Chile",
	"China",
	"Christmas Island",
	"Cocos (Keeling) Islands (the)",
	"Colombia",
	"Comoros (the)",
	"Congo (the Democratic Republic of the)",
	"Congo (the)",
	"Cook Islands (the)",
	"Costa Rica",
	"Croatia",
	"Cuba",
	"Curaçao",
	"Cyprus",
	"Czechia",
	"Côte d'Ivoire",
	"Denmark",
	"Djibouti",
	"Dominica",
	"Dominican Republic (the)",
	"Ecuador",
	"Egypt",
	"El Salvador",
	"Equatorial Guinea",
	"Eritrea",
	"Estonia",
	"Eswatini",
	"Ethiopia",
	"Falkland Islands (the) [Malvinas]",
	"Faroe Islands (the)",
	"Fiji",
	"Finland",
	"France",
	"French Guiana",
	"French Polynesia",
	"French Southern Territories (the)",
	"Gabon",
	"Gambia (the)",
	"Georgia",
	"Germany",
	"Ghana",
	"Gibraltar",
	"Greece",
	"Greenland",
	"Grenada",
	"Guadeloupe",
	"Guam",
	"Guatemala",
	"Guernsey",
	"Guinea",
	"Guinea-Bissau",
	"Guyana",
	"Haiti",
	"Heard Island and McDonald Islands",
	"Holy See (the)",
	"Honduras",
	"Hong Kong",
	"Hungary",
	"Iceland",
	"India",
	"Indonesia",
	"Iran (Islamic Republic of)",
	"Iraq",
	"Ireland",
	"Isle of Man",
	"Israel",
	"Italy",
	"Jamaica",
	"Japan",
	"Jersey",
	"Jordan",
	"Kazakhstan",
	"Kenya",
	"Kiribati",
	"Korea (the Democratic People's Republic of)",
	"Korea (the Republic of)",
	"Kuwait",
	"Kyrgyzstan",
	"Lao People's Democratic Republic (the)",
	"Latvia",
	"Lebanon",
	"Lesotho",
	"Liberia",
	"Libya",
	"Liechtenstein",
	"Lithuania",
	"Luxembourg",
	"Macao",
	"Madagascar",
	"Malawi",
	"Malaysia",
	"Maldives",
	"Mali",
	"Malta",
	"Marshall Islands (the)",
	"Martinique",
	"Mauritania",
	"Mauritius",
	"Mayotte",
	"Mexico",
	"Micronesia (Federated States of)",
	"Moldova (the Republic of)",
	"Monaco",
	"Mongolia",
	"Montenegro",
	"Montserrat",
	"Morocco",
	"Mozambique",
	"Myanmar",
	"Namibia",
	"Nauru",
	"Nepal",
	"Netherlands (the)",
	"New Caledonia",
	"New Zealand",
	"Nicaragua",
	"Niger (the)",
	"Nigeria",
	"Niue",
	"Norfolk Island",
	"Northern Mariana Islands (the)",
	"Norway",
	"Oman",
	"Pakistan",
	"Palau",
	"Palestine, State of",
	"Panama",
	"Papua New Guinea",
	"Paraguay",
	"Peru",
	"Philippines (the)",
	"Pitcairn",
	"Poland",
	"Portugal",
	"Puerto Rico",
	"Qatar",
	"Republic of North Macedonia",
	"Romania",
	"Russian Federation (the)",
	"Rwanda",
	"Réunion",
	"Saint Barthélemy",
	"Saint Helena, Ascension and Tristan da Cunha",
	"Saint Kitts and Nevis",
	"Saint Lucia",
	"Saint Martin (French part)",
	"Saint Pierre and Miquelon",
	"Saint Vincent and the Grenadines",
	"Samoa",
	"San Marino",
	"Sao Tome and Principe",
	"Saudi Arabia",
	"Senegal",
	"Serbia",
	"Seychelles",
	"Sierra Leone",
	"Singapore",
	"Sint Maarten (Dutch part)",
	"Slovakia",
	"Slovenia",
	"Solomon Islands",
	"Somalia",
	"South Africa",
	"South Georgia and the South Sandwich Islands",
	"South Sudan",
	"Spain",
	"Sri Lanka",
	"Sudan (the)",
	"Suriname",
	"Svalbard and Jan Mayen",
	"Sweden",
	"Switzerland",
	"Syrian Arab Republic",
	"Taiwan",
	"Tajikistan",
	"Tanzania, United Republic of",
	"Thailand",
	"Timor-Leste",
	"Togo",
	"Tokelau",
	"Tonga",
	"Trinidad and Tobago",
	"Tunisia",
	"Turkey",
	"Turkmenistan",
	"Turks and Caicos Islands (the)",
	"Tuvalu",
	"Uganda",
	"Ukraine",
	"United Arab Emirates (the)",
	"United Kingdom of Great Britain and Northern Ireland (the)",
	"United States Minor Outlying Islands (the)",
	"United States of America (the)",
	"Uruguay",
	"Uzbekistan",
	"Vanuatu",
	"Venezuela (Bolivarian Republic of)",
	"Viet Nam",
	"Virgin Islands (British)",
	"Virgin Islands (U.S.)",
	"Wallis and Futuna",
	"Western Sahara",
	"Yemen",
	"Zambia",
	"Zimbabwe",
	"Åland Islands"
]

export const ContientList = ['Asia','Africa','Europe','North America','South America','Australia','Antartica']

export const REPORT_PAGE_TABLE_KEYS = [
	{'label':'S.NO.','key':'serial_id','icon': <FaIdCard/>, 'width':'50px' },
	{'label':'Report Name','key':'report_name','icon': <MdDriveFileRenameOutline/> , 'width':'100px'},
	{'label':'Report type','key':'report_type__label','icon': <BsType/> , 'width':'100px'},
	{'label':'Date','key':'date','icon': <FaCalendarTimes/>,'width':'100px'},
	{'label':'User name','key':'user_name','icon': <FaUser/>,'width':'100px'},
	{'label':'Organisation','key':'organisation','icon': <GoGlobe/>,'width':'100px'},
	{'label':'Email','key':'email','icon': <Email/>,'width':'100px'},
	{'label':'Report ID','key':'report_id','icon': <FaIdCard/>,'width':'100px'},
	{'label':'Status','key':'status','icon': <FaSteam/>,'width':'100px'},
	// {'label':'Report ID','key':'status','icon': <FaIdCard/>,'width':'100px'},
	// {'label':'Company Type','key':'company__company_type','icon': <TypeSpecimen/>,'width':'100px'},
	{'label':'Geo','key':'company__geo','icon': <LocationCity/>,'width':'100px'},
	{'label':'Year','key':'company__year','icon': <DateRange/>,'width':'100px'},
	{'label':'Last Funding Date','key':'company__last_funding_date','icon': <DateRange/>,'width':'180px'},
	{'label':'Operating Status','key':'company__operation_status','icon': <MdNotificationsActive/>,'width':'180px'},
	{'label':'# of Employees','key':'company__no_of_employees','icon': <Numbers/>,'width':'100px'},
	{'label':'Website','key':'company__website','icon': <BsGlobe/>,'width':'100px'},
	{'label':'Product Category','key':'company__product_category','icon': <FaCashRegister/>,'width':'250px'},
	{'cut_off':true,'label':'Industry','key':'company__industry','icon': <FaIndustry/>,'width':'300px'},
	// {'cut_off':true,'label':'Company Description','key':'company__description','icon': <Description/>,'width':'300px'},
	{'cut_off':true,'label':'Core offering','key':'company__core_offering','icon': <FaBitcoin/>,'width':'300px'},
]

export const NOTIFICATION_FORM_SETTING = [
    { label: "Title*", type: "text", saveKey: "title" },
    { label: "Description", type: "text__area", saveKey: "description" },
    { label: "User*", type: "user", saveKey: "user" },
    { label: "Report ID", type: "number", saveKey: "report_id" },
    { label: "Date", type: "date__time", saveKey: "date" },
    { label: "Viewed at", type: "date__time", saveKey: "viewed_at" },
    {
      label: "Archived",
      type: "select",
      saveKey: "archived",
      options: [
        { label: "True", value: true },
        { label: "False", value: false },
      ],
    },
    {
      label: "Show in recent",
      type: "select",
      saveKey: "show_in_recent",
      options: [
        { label: "True", value: true },
        { label: "False", value: false },
      ],
    },
    {
      label: "Notification Type*",
      type: "select",
      saveKey: "type",
      options: [],
    },
    { label: "Meta", type: "json", saveKey: "meta" },
    { label: "Action url", type: "text", saveKey: "action_url" },
]


export const NOTIFICATION_TABLE_KEYS  = [
		{
			label: "ID",
			key: "id",
			width: "10%",
		},
		{
			label: "User",
			key: "user",
			width: "10%",
		},
		{
			label: "Title",
			key: "title",
			width: "10%",
		},
		// {
		// 	label: "Description",
		// 	key: "description",
		// 	width: "10%",
		// },
		{
			label: "Type",
			key: "type",
			width: "10%",
		},
		{
			label: "Viewed at",
			key: "viewed_at",
			width: "10%",
		},
		{
			label: "Show In Recent",
			key: "show_in_recent",
			width: "10%",
		},
		// {
		// 	label: "Action Url",
		// 	key: "action_url",
		// 	width: "10%",
		// },
		{
			label: "Report id",
			key: "report_id",
			width: "10%",
		},
		{
			label: "Archived",
			key: "archived",
			width: "10%",
		},
]  

export const REPORT_LIST_TABLE_KEYS = [
    {
        label: "",
        key: "checkbox",
        width: "5%",
    },
    {
        label: "Report Name",
        key: "title",
        width: "15%",
    },
    {
        label: "Report type",
        key: "type",
        width: "10%",
    },
    {
        label: "Date",
        key: "last_updated_on",
        width: "10%",
    },
    {
        label: "User name",
        key: "username",
        width: "10%",
    },
    {
        label: "Organisation",
        key: "org_name",
        width: "10%",
    },
    {
        label: "Email",
        key: "email",
        width: "15%",
    },
    {
        label: "Report ID",
        key: "id",
        width: "10%",
    },
{
        label: "Status",
        key: "status",
        width: "10%",
    },
];

export const PRODUCT_VIDEO_FORM_SETTING = [
	{ label: "Title*", type: "text", saveKey: "title" },
	{ label: "Description", type: "text__area", saveKey: "description" },
	{ label: "Thumbnail Image URL", type: "file", saveKey: "thumbnail_img" },
	{ label: "Video Source URL", type: "text", saveKey: "video_src" },
	{ label: "Type", type: "select", saveKey: "type", options: [
		{ label: "Features Videos", value: "features_videos" },
		{ label: "Onboarding Videos", value: "onboarding_videos" },
		{ label: "Product Videos", value: "product_videos" },
		{ label: "Other", value: "other" },
	] },
	{ label: "Is Sidebar Video?", type: "select", saveKey: "is_sidebar_video", options: [
		{ label: "True", value: true },
		{ label: "False", value: false },
	] },
]
export const PRODUCT_VIDEO_FORM_SETTING_META = [
	{ label: "Time", type: "time", saveKey: "time" },
	{ label: "Order", type: "number", saveKey: "order" },
	{ label: "Feature Type", type: "text", saveKey: "feature_type"},
	{ label: "Is Home?", type: "select", saveKey: "home", options: [
		{ label: "True", value: true },
		{ label: "False", value: false },
	] },
	{ label: "Report Type", type: "text", saveKey: "report_type" },
	{ label: "Email/Video Description", type: "text_area", saveKey: "email_video_desc" },
	{ label: "Feature Card Key", type: "text", saveKey: "feature_card_key" },
]
export const PRODUCT_VIDEO_TABLE_KEYS = [
	{
		label: "ID",
		key: "id",
		width: "10%",
	},
	{
		label: "Thumbnail Image URL",
		key: "thumbnail_img",
		width: "10%",
	},
	{
		label: "Title",
		key: "title",
		width: "10%",
	},
	{
		label: "Description",
		key: "description",
		width: "10%",
	},
	{
		label: "Video Source URL",
		key: "video_src",
		width: "10%",
	},
	{
		label: "Type",
		key: "type",
		width: "10%",
	},	
	{
		label: "Date Created",
		key: "createdOn",
		width: "10%",
	},
	{
		label: "Is Sidebar Video?",
		key: "is_sidebar_video",
		width: "10%",
	}
]
export const NEWSLETTER_ACCESS_FORM_SETTINGS = [
	{
		label: "Notification Type*",
		type: "select",
		saveKey: "newsletter_type__pk",
		options: [],
	},
	{ label: "Organization*", type: "org", saveKey: "org_name__pks" },
	{
		label: "Is admin only",
		type: "select",
		saveKey: "is_admin_only",
		options: [
		  { label: "Yes", value: true },
		  { label: "No", value: false },
		],
	},
	{
		label: "Is user only",
		type: "select",
		saveKey: "is_user_only",
		options: [
		  { label: "Yes", value: true },
		  { label: "No", value: false },
		],
	},
	{
		label: "Is hidden",
		type: "select",
		saveKey: "is_hidden",
		options: [
		  { label: "Yes", value: true },
		  { label: "No", value: false },
		],
	},
]

export const SCHEDULER_FORM_SETTINGS = [
	[
		{
			label: "Time*",
			type: "time",
			saveKey: "time",
			options: [],
		},
		{
			label: "Start date*",
			type: "date",
			saveKey: "start_date",
			options: [],
		},
		{
			label: "Mode*",
			type: "select",
			saveKey: "mode",
			options: [
				{ label: "Onetime", value: "onetime" },
				{ label: "Daily", value: "daily" },
				{ label: "Weekly", value: "weekly" },
				{ label: "Monthly", value: "monthly" },
			],
		}
	],
	[
		{
			label: "Updated Analysis Period(Optional)(in days)",
			type: "number",
			saveKey: "analysis_period",
		}
	],
	[
		{
			label: "Scheduler Mode",
			type: "select",
			saveKey: "scheduler_mode",
			options:
			[
				{
					'label':'Newsletter',
					'value':'newsletter'
				},
				{
					'label':'Other',
					'value':'other'
				},
				{
					'label':'Task',
					'value':'task'
				},
			]
		}
	],
	[
		{
			label: "API*",
			type: "text",
			saveKey: "api",
		},
		{
			label: "Headers",
			type: "text",
			saveKey: "headers",
		},
		{
			label: "Payload",
			type: "text",
			saveKey: "payload",
		},
		{
			label: "Request type",
			type: "select",
			saveKey: "request_type",
			options:[
				{'label':'GET',value:'GET'},
				{'label':'POST',value:'POST'},
			]
		}
	],
	[
		{
			label: "Name*",
			type: "text",
			saveKey: "name",
		},
		{
			label: "Queue",
			type: "text",
			saveKey: "queue",
		},
	]
]

export const NEWSLETTER_CONFIG_TABLE_KEYS  = [
	{
		label: "ID",
		key: "id",
		width: "5%",
	},
	{
		label: "Newsletter type",
		key: "newsletter_type",
		width: "5%",
	},
	{
		label: "username",
		key: "username",
		width: "10%",
	},
	{
		label: "uuid",
		key: "uuid",
		width: "10%",
	},
	{
		label: "Analysis Period",
		key: "analysis_period",
		width: "5%",
	},
	{
		label: "Frequency",
		key: "frequency_of_newsletter",
		width: "5%",
	},
	{
		label: "Number of Themes",
		key: "no_of_themes",
		width: "5%",
	},
	{
		label: "Publish state",
		key: "publish_state",
		width: "5%",
	},
	{
		label: "Org name",
		key: "org_name",
		width: "5%",
	},
	{
		label: "CC Count",
		key: "cc_count",
		width: "5%",
	},
]

export const NEWSLETTER_ALL_TRIGGERS_TABLE_KEYS = [
	{
		label: "ID",
		key: "pk",
		width: "5%",
	},
	{
		label: "Mode",
		key: "mode",
		width: "5%",
	},
	{
		label: "Time",
		key: "time",
		width: "5%",
	},
	{
		label: "Date",
		key: "date",
		width: "5%",
	},
	{
		label: "Extra details",
		key: "extra_details",
		width: "5%",
	},
	{
		label: "Updated A.P",
		key: "analysis_period",
		width: "5%",
	},
	{
		label: "Original A.P",
		key: "original_analysis_period",
		width: "5%",
	},
	{
		label: "Username",
		key: "username",
		width: "5%",
	},
	{
		label: "Config ID",
		key: "config_id",
		width: "5%",
	},
	{
		label: "Is other",
		key: "is_other",
		width: "5%",
	},{
		label: "Last run",
		key: "last_run",
		width: "5%",
	},
	{
		label: "Active",
		key: "active",
		width: "5%",
	},
]

export const weekdaysOptions = [
		{value:0,label:'Monday'},
		{value:1,label:'Tuesday'},
		{value:2,label:'Wednesday'},
		{value:3,label:'Thursday'},
		{value:4,label:'Friday'},
		{value:5,label:'Saturday'},
		{value:6,label:'Sunday'}
	]
export const monthsOptions = [
		{ 'value': 1, 'label': 'January' }, 
		{ 'value': 2, 'label': 'February'}, 
		{ 'value': 3, 'label': 'March' }, 
		{ 'value': 4, 'label': 'April' }, 
		{ 'value': 5, 'label': 'May' }, 
		{ 'value': 6, 'label': 'June' },
		{ 'value': 7, 'label': 'July' }, 
		{ 'value': 8, 'label': 'August' }, 
		{ 'value': 9, 'label': 'September' }, 
		{ 'value': 10, 'label': 'October' }, 
		{ 'value': 11, 'label': 'November' }, 
		{ 'value': 12, 'label': 'December' }
	]
export const dayOptions = [
		{ 'value': 1, 'label': '1' },
		{ 'value': 2, 'label': '2' },
		{ 'value': 3, 'label': '3' }, 
		{ 'value': 4, 'label': '4' },
		{ 'value': 5, 'label': '5' },
		{ 'value': 6, 'label': '6' },
		{ 'value': 7, 'label': '7' },
		{ 'value': 8, 'label': '8' },
		{ 'value': 9, 'label': '9' },
		{ 'value': 10, 'label': '10' },
		{ 'value': 11, 'label': '11' },
		{ 'value': 12, 'label': '12' },
		{ 'value': 13, 'label': '13' },
		{ 'value': 14, 'label': '14' },
		{ 'value': 15, 'label': '15' }, 
		{ 'value': 16, 'label': '16' },
		{ 'value': 17, 'label': '17' },
		{ 'value': 18, 'label': '18' },
		{ 'value': 19, 'label': '19' },
		{ 'value': 20, 'label': '20' },
		{ 'value': 21, 'label': '21' },
		{ 'value': 22, 'label': '22' },
		{ 'value': 23, 'label': '23' },
		{ 'value': 24, 'label': '24' },
		{ 'value': 25, 'label': '25' },
		{ 'value': 26, 'label': '26' },
		{ 'value': 27, 'label': '27' },
		{ 'value': 28, 'label': '28' },
	]

export const PENDING_REQUESTS_TABLE_COLUMNS = [
		{
			label: "ID",
			key: "pk",
			width: "5%",
		},
		{
			label: "Username",
			key: "user",
			width: "50%",
		},
		{
			label: "Status",
			key: "status",
			width: "45%",
		}
]

export const TABLE_COLUMN_REPORT_TYPES = [
	{
		label: "ID",
		key: "pk",
		width: "5%",
	},
	{
		label: "Name",
		key: "name",
		width: "5%",
	},
	{
		label: "Label",
		key: "label",
		width: "5%",
	},
	{
		label: "Description",
		key: "description",
		width: "5%",
	},
	{
		label: "Order preference",
		key: "order_preference",
		width: "5%",
	},
	{
		label: "Is Sandbox",
		key: "is_sandbox",
		width: "5%",
	},
	{
		label: "Count",
		key: "org_count_to_rt_mapping.org_count",
		width: "5%",
	},
	// {
	// 	label: "Is locked",
	// 	key: "is_locked",
	// 	width: "5%",
	// },
	// {
	// 	label: "Is beta",
	// 	key: "is_beta",
	// 	width: "5%",
	// },
	// {
	// 	label: "Is pro",
	// 	key: "is_pro",
	// 	width: "5%",
	// },
	// {
	// 	label: "Is hidden",
	// 	key: "is_hidden",
	// 	width: "5%",
	// },
	{
		label: "Active",
		key: "active",
		width: "5%",
	},
	{
		label: "Category",
		key: "category",
		width: "5%",
	}
]	

export const FORM_SETTING_REPORT_TYPE_EDIT = [
	{
		label: "Label*",
		type: "text",
		saveKey: "label",
	},
	{
		label: "Description*",
		type: "text",
		saveKey: "description",
	},
	{
		label: "is_sandbox*",
		type: "select",
		saveKey: "is_sandbox",
		options:[
			{'label':'True',value:true},
			{'label':'False',value:false},
		],
	},
	{
		label: "Order preference*",
		type: "number",
		saveKey: "order_preference",
	},
	{
		label: "Name",
		type: "text",
		saveKey: "name",
		readonly:true
	},
	{
		label: "Icon",
		type: "text",
		saveKey: "icon",
	},
	// {
	// 	label: "Is default",
	// 	type: "select",
	// 	saveKey: "is_default",
	// 	options:[
	// 		{'label':'True',value:true},
	// 		{'label':'False',value:false},
	// 	],
	// 	readonly:true
	// },
	// {
	// 	label: "Is locked",
	// 	type: "select",
	// 	saveKey: "is_locked",
	// 	options:[
	// 		{'label':'True',value:true},
	// 		{'label':'False',value:false},
	// 	],
	// 	readonly:true
	// },
	// {
	// 	label: "Is beta",
	// 	type: "select",
	// 	saveKey: "is_beta",
	// 	options:[
	// 		{'label':'True',value:true},
	// 		{'label':'False',value:false},
	// 	],
	// 	readonly:true
	// },
	// {
	// 	label: "Is Pro",
	// 	type: "select",
	// 	saveKey: "is_pro",
	// 	options:[
	// 		{'label':'True',value:true},
	// 		{'label':'False',value:false},
	// 	],
	// 	readonly:true
	// },
	// {
	// 	label: "Is Hidden",
	// 	type: "select",
	// 	saveKey: "is_hidden",
	// 	options:[
	// 		{'label':'True',value:true},
	// 		{'label':'False',value:false},
	// 	],
	// 	readonly:true
	// },
	{
		label: "active",
		type: "select",
		saveKey: "active",
		options:[
			{'label':'True',value:true},
			{'label':'False',value:false},
		],
		readonly:true
	},
	{
		label: "Meta",
		type: "json",
		saveKey: "meta",
	},
] 

export const BREAK_POINT_TABLE_SETTINGS = [
	{
		label: "Name",
		key: "name",
		width: "5%",
	},
	{
		label: "Last modified",
		key: "last_modified",
		width: "5%",
	},
	// {
	// 	label: "Path",
	// 	key: "path",
	// 	width: "5%",
	// }
]

export const CB_ENRICHMENT_PRESETS = [
	{
		"label":"Standard CB Enrichment",
		"mapping":{
		  "description":{
		  "key":"description",
		  "label":"Description",
		  "settings":{
			"blocked_keys":[]
		  }},
		  "permalink":{
		  "key":"permalink",
		  "label":"Permalink",
		  "settings":{
			"blocked_keys":[]
		  }},
		  "list_investments":{
		  "key":"list_investments",
		  "label":"Portfolio Comps",
		  "settings":{
			"blocked_keys":[
			  "news",
			  "image",
			  "org_uuid",
			  "permalink",
			  "investment_uuid",
			  "funding_round_uuid"
			]
		  }},
		  "website":{
		  "key":"website",
		  "label":"Website",
		  "settings":{
			"blocked_keys":[
			]
		  }},
		  "org_name":{
		  "key":"org_name",
		  "label":"Name (Crunchbase)",
		  "settings":{
			"blocked_keys":[
			]
		  }},
		  "primary_role":{
		  "key":"primary_role",
		  "label":"Roles",
		  "settings":{
			"blocked_keys":[
			]
		  }},
		  "country":{
		  "key":"country",
		  "label":"Country",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "continent":{
		  "key":"continent",
		  "label":"Continent",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "hq":{
		  "key":"hq",
		  "label":"HQ",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "num_employees":{
		  "key":"num_employees",
		  "label":"# Employees",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "url":{
		  "key":"url",
		  "label":"Crunchbase URL",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "investor_stage":{
		  "key":"investor_stage",
		  "label":"Focus Stage",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "funds_total_value":{
		  "key":"funds_total_value",
		  "label":"Funds Total Value",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "revenue_range":{
		  "key":"revenue_range",
		  "label":"Revenue (Crunchbase)",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		  ,
		  "stock_symbol":{
		  "key":"stock_symbol",
		  "label":"Stock Symbol",
		  "settings":{
			"blocked_keys":[
			]
		  }}
		}
		
	}
]

export const FORM_SETTING_COMPANY_NEWS = [
	{
		label: "Permalink*",
		type: "text",
		saveKey: "permalink",
	},
	{
		label: "Title*",
		type: "text",
		saveKey: "title",
	},
	{
		label: "Author",
		type: "text",
		saveKey: "author",
	},
	{
		label: "Url*",
		type: "text",
		saveKey: "url",
	},
	{
		label: "Publisher*",
		type: "text",
		saveKey: "publisher",
	},
	{
		label: "Published date*",
		type: "date",
		saveKey: "published_date",
	}
]	

export const TABLE_SETTING_COMPANY_NEWS = [
	{
		label: "ID",
		key: "id",
		width: "5%",
	},
	{
		label: "Permalink",
		key: "permalink",
		width: "5%",
	},
	{
		label: "Title",
		key: "title",
		width: "5%",
	},
	{
		label: "Author",
		key: "author",
		width: "5%",
	},
	{
		label: "Url",
		key: "url",
		width: "5%",
	},
	{
		label: "Publisher",
		key: "publisher",
		width: "5%",
	},
	{
		label: "Published date",
		key: "published_date",
		width: "5%",
	},
]	

export const NEWSLETTER_RUN_FORM_DATA = [
	{
		label: "is_industry_sourcing_on",
		type: "select",
		saveKey: "is_industry_sourcing_on",
		options:[
			{'label':'True',value:true},
			{'label':'False',value:false},
		],
	},
	{
		label: "is_company_sourcing_on",
		type: "select",
		saveKey: "is_company_sourcing_on",
		options:[
			{'label':'True',value:true},
			{'label':'False',value:false},
		],
	}
] 

export const OBSERVABILITY_METRICS_TABLE_KEYS  = [
		{
			label: "Name",
			key: "name",
			width: "30%",
		},
		{
			label: "Success",
			key: "success",
			width: "10%",
		},
		{
			label: "Success Percentage",
			key: "success_percentage",
			width: "10%",
		},
		{
			label: "Failed",
			key: "failed",
			width: "10%",
		},
		{
			label: "Failed Percentage",
			key: "failed_percentage",
			width: "10%",
		},
		{
			label: "No data",
			key: "no data",
			width: "10%",
		},
		{
			label: "Not started",
			key: "not started",
			width: "5%",
		},
		{
			label: "Total",
			key: "total",
			width: "10%",
		},
]

export const OBSERVABILITY_LOGS_TABLE_KEYS  = [
		{
			label: "Name",
			key: "name",
			width: "50%",
		},
		{
			label: "Created On",
			key: "createdOn",
			width: "10%",
		},
		{
			label: "Report ID",
			key: "report_id",
			width: "10%",
		},
		{
			label: "Report type",
			key: "report_type",
			width: "10%",
		},
		{
			label: "Category label",
			key: "category__label",
			width: "10%",
		},
		{
			label: "Status",
			key: "status",
			width: "10%",
		},
]

export const NEWSLETTER_REVIVER_FORM_CONFIG = {
  step1: [
    {
      label: "Industry Reference ID",
      saveKey: "step1_industry_id",
      type: "number",
    },
    {
      label: "Industry Mode",
      saveKey: "step1_industry_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
    {
      label: "Company Reference ID",
      saveKey: "step1_company_id",
      type: "number",
    },
    {
      label: "Company Mode",
      saveKey: "step1_company_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
  step2: [
    {
      label: "Task ID",
      saveKey: "step2_task_id",
      type: "number",
    },
    {
      label: "Task Name",
      saveKey: "step2_task_name",
      type: "text",
      readonly: false,
    },
	 {
      label: "Reference ID",
      saveKey: "step2_reference_id",
      type: "number",
    },
    {
      label: "Mode",
      saveKey: "step2_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
  step3: [
    {
      label: "Task ID",
      saveKey: "step3_task_id",
      type: "number",
    },
    {
      label: "Task Name",
      saveKey: "step3_task_name",
      type: "text",
      readonly: false,
    },
	
	 {
      label: "Reference ID",
      saveKey: "step3_reference_id",
      type: "number",
    },
    {
      label: "Mode",
      saveKey: "step3_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
  step4: [
	  {
      label: "Task ID",
      saveKey: "step4_task_id",
      type: "number",
    },
    {
      label: "Reference ID",
      saveKey: "step4_reference_id",
      type: "number",
    },
  
    {
      label: "Mode",
      saveKey: "step4_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
  step5: [
    {
      label: "Task ID",
      saveKey: "step5_task_id",
      type: "number",
    },
    {
      label: "Task Name",
      saveKey: "step5_task_name",
      type: "text",
      readonly: false,
    },
	
	 {
      label: "Reference ID",
      saveKey: "step5_reference_id",
      type: "number",
    },
    {
      label: "Mode",
      saveKey: "step5_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
  step6: [
    {
      label: "TaskID",
      saveKey: "step6_task_id",
      type: "number",
    },
	  {
      label: "Task Name",
      saveKey: "step6_task_name",
      type: "text",
      readonly: false,
    },
	 {
      label: "Reference ID",
      saveKey: "step6_reference_id",
      type: "number",
    },
    {
      label: "Mode",
      saveKey: "step6_mode",
      type: "select",
      options: [
        { label: "Fire", value: "fire" },
        { label: "Count", value: "count" },
      ],
    },
  ],
};


export const NEWSLETTER_MIGRATION_FORM_SETTINGS = [
	{ label: "Newsletter Link", type: "text", saveKey: "newsletter_link" },
    {
      label: "Publish State",
      type: "select",
      saveKey: "publish_state",
      options: [
        { label: "Publish", value: "Publish" },
        { label: "Unpublish", value: "Unpublish" },
        { label: "Draft", value: "Draft" }
      ]
    },
	{label: "Sent Email" , type: "select", saveKey: "sent_mail", 
		options:[
			{'label':'True',value:true , default:true},
			{'label':'False',value:false},
		]
	},
    { label: "POC (User)", type: "user", saveKey: "poc", single: true},
    { label: "CC (Users)", type: "user", saveKey: "cc" },
]

export const REPORT_TRACEBILITY_FORM_CONFIG = [
	{
	  label: 'Report ID',
	  type: 'number',
	  saveKey: 'reportId',
	  placeholder: 'Enter Report ID to fetch data',
	},
  ];
  ;
export const ENGLISH_TRANSLATOR_FORM_SETTINGS = [
  {
    label: "Report ID*",
    type: "number",
    saveKey: "report_id",
  },
];

export const PPT_QUERY_FORM_SETTINGS = [
  {
    label: "Report ID*",
    type: "number",
    saveKey: "report_id",
  },
  {
    label: "Query*",
    type: "text",
    saveKey: "query",
  },
  {
    label: "Organization*",
    type: "org",
    saveKey: "org",
	single: true
  },
];

export const DB_MIGRATION_FORM_CONFIG = [
	{ label: "Table Name", type: "select", saveKey: "table_name",
		options: [
			{ label: "Prompts", value: "prompts" },
			{ label: "Notification Type", value: "notification_type" },
			{ label: "WKL AI Model", value: "aimodel" },
			{ label: "WKL AI Model Parameter", value: "aimodel_parameter" },
			{ label: "WKL AI Model Library", value: "aimodel_library" },
			{ label: "WKL AI Model Provider", value: "aimodel_provider" },
			{ label: "WKL Configuration", value: "configuration" },
			{ label: "WKL Credential", value: "credential" },
			{ label: "WKL Credential Type", value: "credential_type" },
			{ label: "WKL Function", value: "function" },
			{ label: "WKL Parameter", value: "parameter" },
			{ label: "WKL Prompt", value: "prompt" },
			{ label: "WKL Prompt Parameter", value: "prompt_parameter" },
			{ label: "WKL System Prompt", value: "system_prompt" },
			{ label: "WKL User Preference Type", value: "user_preference_type" },
      ], 
	 },
	{ label: "From DB", type: "select", saveKey: "from_db", 
		options: [
			{ label: "Production", value: "prod_db"  },
			{ label: "Test", value: "test_db" },
			{ label: "Source", value: "source_db" },
		  ], 
	 },
	{ label: "To DB", type: "select", saveKey: "to_db", 
		options: [
			{ label: "Production", value: "prod_db"  },
			{ label: "Test", value: "test_db" },
			{ label: "Source", value: "source_db" },
		  ], 
	 },
  ];


  export const ATLAS_SEARCH_FORM1 = [
	{ label: "Function name", saveKey: "function_name", type: "text" },
	{ label: "Function path", saveKey: "function_path", type: "text" },
	{ label: "Short description", saveKey: "function_description", type: "text" },
	{ label: "Long description", saveKey: "function_long_description", type: "text__area" },
  ];

  export const ATLAS_SEARCH_FORM2 = [
	{ label: "Project", saveKey: "metadata.project", type: "text" },
	{ label: "Module", saveKey: "metadata.module", type: "text" },
	{ label: "Analyzed date", saveKey: "metadata.analyzed_date", type: "date__time" },
	{ label: "File extension", saveKey: "metadata.file_extension", type: "text" },
	{ label: "Category", saveKey: "metadata.category", type: "text" },
	{ label: "Has docstring (true/false)", saveKey: "metadata.has_docstring", type: "text" },
	{ label: "Has parameters (true/false)", saveKey: "metadata.has_parameters", type: "text" },
	{ label: "Function signature", saveKey: "metadata.function_signature", type: "text" },
  ];


export const AFFINITY_FORM_SETTINGS = [
	{ label: "API Key", type: "text", saveKey: "api_key" },
	{ label: "List ID", type: "number", saveKey: "list_id" },
	{ children:null, type: "div", saveKey: "fields" },
	// { label: "Base Condition", type: "text", saveKey: "base_condition" },
	{label: "Primary key during update", type: "react-single-select", saveKey: "primary_key_during_update" ,options:[]},
	{ label: "Workflow ID", type: "react-single-select", saveKey: "workflow_id" , options:[]},
	{label: "Owner", type: "react-single-select", saveKey: "owner" ,options:[]},
]

export const FakeFieldData = [
	{
        "id": 5105709,
        "name": "Status",
        "list_id": 297640,
        "enrichment_source": "none",
        "value_type": 7,
        "allows_multiple": false,
        "track_changes": true,
        "dropdown_options": [
            {
                "id": 19523674,
                "text": "New",
                "rank": 0,
                "color": 3
            },
            {
                "id": 19523675,
                "text": "In Progress",
                "rank": 1,
                "color": 3
            },
            {
                "id": 19523676,
                "text": "Won",
                "rank": 2,
                "color": 2
            },
            {
                "id": 19523677,
                "text": "Lost",
                "rank": 3,
                "color": 1
            },
            {
                "id": 19523678,
                "text": "On Hold",
                "rank": 4,
                "color": 5
            }
        ]
    },
    {
        "id": 5105711,
        "name": "Owners",
        "list_id": 297640,
        "enrichment_source": "none",
        "value_type": 0,
        "allows_multiple": true,
        "track_changes": true,
        "dropdown_options": []
    },
    {
        "id": 5105710,
        "name": "Amount",
        "list_id": 297640,
        "enrichment_source": "none",
        "value_type": 3,
        "allows_multiple": false,
        "track_changes": true,
        "dropdown_options": []
    },
    {
        "id": 5481786,
        "name": "Data To Fill",
        "list_id": 297640,
        "enrichment_source": "none",
        "value_type": 6,
        "allows_multiple": false,
        "track_changes": false,
        "dropdown_options": []
    },
    {
        "id": 5472121,
        "name": "Test field",
        "list_id": 297640,
        "enrichment_source": "none",
        "value_type": 6,
        "allows_multiple": false,
        "track_changes": false,
        "dropdown_options": []
    }
]
export const NewListFields = [
                    {
                "id": "list_id",
                "name": "List ID",
                "list_id": 297640,
                "enrichment_source": "none",
                "value_type": 'list_id',
                "allows_multiple": true,
                "track_changes": true,
                "dropdown_options": []
            },
            {
                  "id": "new_company",
                  "name": "New Company",
                  "list_id": 297640,
                  "enrichment_source": "none",
                  "value_type": 'new_company',
                  "allows_multiple": true,
                  "track_changes": true,
              'valueEditorType': 'checkbox',
                  "dropdown_options": [],
                  'defaultValue': false,
              },
          ]
export const VALUE_TYPE_TO_NAME_MAPPINGS = {
	0:'Person',
	1:'Organization',
	2:'Dropdown',
	3:'Number',
	4:'Date',
	5:'Location',
	6:'Text',
	7:'Ranked Dropdown',
	"new_company":"new_company",
	"list_id":"list_id"
}

export const ALL_AFFINITY_TABLE = [
	{
		label: "ID",
		key: "unique_affinity_id",
		width: "5%",
	},
	{
		label: "API key",
		key: "api_key",
		width: "5%",
	},
	{
		label: "List id",
		key: "list_id",
		width: "5%",
	},
	{
		label: "Workflow",
		key: "workflow_id",
		width: "5%",
	},
	{
		label: "active",
		key: "active",
		width: "5%",
	},
]

export const CREDIT_HISTORY_TABLE_COLUMNS = [
	{ key: "id", label: "ID", width: "8%" },
	{ key: "org_name", label: "Organisation", width: "12%" },
	{ key: "transaction_type", label: "Type", width: "10%" },
	{ key: "amount", label: "Amount", width: "10%" },
	{ key: "type", label: "Context", width: "10%" },
	{ key: "title", label: "Title", width: "15%" },
	{ key: "sub_info", label: "Description", width: "15%" },
	{ key: "username", label: "By", width: "10%" },
	{ key: "created_at", label: "Date", width: "10%" },
];

export const CREDIT_ORG_FORM_SETTINGS = [
	{ label: "Organisation*", type: "org", saveKey: "org", single: true },
];

export const CREDIT_FORM_SETTINGS = [
	{ label: "Organisation*", type: "org", saveKey: "org" ,single: true },
	{ label: "Mode*", type: "select", saveKey: "mode", options: [
		{ label: "Credit (Add)", value: "credit" },
		{ label: "Debit (Minus)", value: "debit" },
	]},
	{ label: "Amount*", type: "number", saveKey: "amount" },
	{ label: "Context Type", type: "text", saveKey: "type", placeholder: "e.g. assistant", description: "Context type (e.g. 'assistant')" },
	{ label: "Reference ID", type: "text", saveKey: "id_ref", placeholder: "e.g. msg_abc123", description: "Reference ID (e.g. message/chat ID)" },
	{ label: "Title", type: "text", saveKey: "title", placeholder: "Transaction title", description: "Title or label for the transaction" },
	{ label: "Description", type: "text", saveKey: "sub_info", placeholder: "Additional details", description: "Additional sub-information or description" },
];

export const API_USAGE_FORM_SETTINGS = {
	filters: [
		{ label: "Method", type: "select", saveKey: "method", options: [
			{ label: "All Methods", value: "" },
			{ label: "GET", value: "GET" },
			{ label: "POST", value: "POST" },
			{ label: "PUT", value: "PUT" },
			{ label: "DELETE", value: "DELETE" },
		]},
		{ label: "Status", type: "select", saveKey: "status", options: [
			{ label: "All Status", value: "" },
			{ label: "Pending", value: "pending" },
			{ label: "Success", value: "success" },
			{ label: "Failed", value: "failed" },
			{ label: "Insufficient Credits", value: "insufficient_credits" },
		]},
		{ label: "Endpoint", type: "select", saveKey: "endpoint", options: [] },
		{ label: "Source", type: "select", saveKey: "client_source", options: [
			{ label: "All Sources", value: "" },
			{ label: "API", value: "API" },
			{ label: "MCP", value: "MCP" },
		]},
		{ label: "Page Size", type: "select", saveKey: "page_size", options: [
			{ label: "25", value: "25" },
			{ label: "50", value: "50" },
			{ label: "100", value: "100" },
			{ label: "200", value: "200" },
		]},
	],
};

export const API_USAGE_TABLE_SETTINGS = {
	columns: [
		{ key: "method", label: "Method", width: "15%" },
		{ key: "endpoint", label: "Endpoint", width: "30%" },
		{ key: "status", label: "Status", width: "15%" },
		{ key: "time_taken", label: "Time", width: "10%" },
	]
};